<template>
  <div class="color-sample-items">
    <template v-if="items.length>0">
      <color-sample-item
          v-for="(item,key) in items" :key="key"
               :color="item.color"
               :quantity="item.qty"
               :unit-price="item.unit_price"
               :can-modify-quantity="canModifyQuantity"
               :can-modify-structure="canModifyStructure"
               :set-structure="item.structure"
               :action-url="actionUrl"
               :structures="structures"
               :currency="currency"
               @updateCartData="onUpdateCartData"

      />
    </template>
    <template v-else>
      <div class="color-sample-empty-cart">
        <h2>{{ trans('sample_order_empty_cart_title') }}</h2>
        <p class="bodytext">{{ trans('sample_order_empty_cart_text') }}</p>
        <a :href="getInspirationLink">{{ getInspirationLabel }}</a>
      </div>
    </template>
  </div>
</template>

<script>
import ColorSampleItem from './ColorSampleItem';
import {translate} from "../service/translation";
export default {
  components: {
    ColorSampleItem
  },
  props : {
    canModifyQuantity : {
      required : false,
      type : Boolean,
      default : true
    },
    canModifyStructure: {
      required : false,
      type : Boolean,
      default : true
    },
    items : {
      required : true,
      type: Array
    },
    structures : {
      required : false,
      type : Array,
      default : function() {
        return [];
      }
    },
    actionUrl : {
      required : false,
      type : String
    },
    currency : {
      required : true,
      type : String
    }
  },
  methods : {
    onUpdateCartData(cartData){
      this.$emit('updateCartData', cartData);
    },
     trans(key){
        return translate(key);
      },
  },
  computed : {
      getInspirationLink : function() {
        return window.colorInspirationLink;
      },
      getInspirationLabel : function() {
        return window.colorInspirationLabel;
      },
      
    },
}
</script>

<style>
  .color-sample-items {
    width:100%;
  }
  .color-sample-empty-cart{
    padding:15px;
    margin:15px auto;
    text-align:center;
    max-width:480px;
    width:100%;
  }
  .color-sample-empty-cart p.bodytext{
    line-height:1.3;
    margin-bottom:5px;
  }
  .color-sample-empty-cart a{
    text-decoration: underline;
  }
</style>
